import { z } from "zod";

import { currencyToNumber } from "@core/utils/masks";

export const tierSchema = () =>
  z.object({
    name: z.string().min(1),
    rank: z.coerce.number().int(),
    min_sales_value: z.preprocess(currencyToNumber, z.number().min(0)),
    commission_percentage: z.coerce.number().min(0).max(100),
  });

export type TierFormValues = z.infer<ReturnType<typeof tierSchema>>;
